export const DEFAULT_ALERT_THRESHOLD = 50;
